module.exports = __webpack_public_path__ + "img/frozen_cut_beans.b3365a6f.jpg";